var _defs, _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIconFlickr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1d3d4;}.cls-2{fill:#fff;}.cls-3{fill:none;}.cls-4{fill:#3766b0;}.cls-5{fill:#ed1f83;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flickr-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,29A14,14,0,1,0,1,15,14,14,0,0,0,15,29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.32,13a2,2,0,1,0,2,2,2,2,0,0,0-2-2m10-2.54v9.11a2.74,2.74,0,0,1-2.73,2.73H10.44a2.73,2.73,0,0,1-2.73-2.73V10.44a2.73,2.73,0,0,1,2.73-2.73h9.11a2.73,2.73,0,0,1,2.73,2.73M17.68,13a2,2,0,1,0,2,2,2,2,0,0,0-2-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15,
    cy: 15,
    r: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12.32,
    cy: 15.05,
    r: 2.01
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 17.68,
    cy: 15,
    r: 2.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFlickr);
export default __webpack_public_path__ + "static/media/social-icon-flickr.22b062fef1809a16827698f7800fa02e.svg";
export { ForwardRef as ReactComponent };